import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { ProtectedRoute } from "@/components/site/ProtectedRoute";
import Home from "@/pages/Home";
import Apply from "@/pages/Apply";
import AnnouncementsPage from "@/pages/AnnouncementsPage";
import Announcements from "@/pages/admin/Announcements";
import Login from "@/pages/Login";
import SetPassword from "@/pages/SetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import Applicants from "@/pages/admin/Applicants";
import ApplicantDetail from "@/pages/admin/ApplicantDetail";
import Members from "@/pages/admin/Members";
import Farms from "@/pages/admin/Farms";
import Inbox from "@/pages/admin/Inbox";
import Emails from "@/pages/admin/Emails";
import AdminSettings from "@/pages/admin/AdminSettings";
import MemberPortal from "@/pages/member/MemberPortal";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/apply" element={<Apply />} />
              <Route path="/announcements" element={<AnnouncementsPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/set-password" element={<SetPassword />} />
              <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
                <Route index element={<Navigate to="applicants" replace />} />
                <Route path="applicants" element={<Applicants />} />
                <Route path="applicants/:id" element={<ApplicantDetail />} />
                <Route path="members" element={<Members />} />
                <Route path="farms" element={<Farms />} />
                <Route path="inbox" element={<Inbox />} />
                <Route path="emails" element={<Emails />} />
                <Route path="announcements" element={<Announcements />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
              <Route path="/member" element={<ProtectedRoute role="member"><MemberPortal /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </SettingsProvider>
    </ThemeProvider>
  );
}

export default App;
